import { em } from 'polished'
import styled, { css } from 'styled-components'

import { TextLH } from 'styles/components/typography'

export const Inner = styled.div`
  color: ${p => (p.colorTheme === 'dark' ? p.theme.colors.white : null)};
  display: flex;
  align-items: center;
  padding: ${p => (p.indicator === 'plus' ? em(20) : em(30))} 0;
  cursor: pointer;
  transition-property: border-color, opacity;
  transition-duration: ${p => p.theme.animation.timeStandard};
  opacity: ${p => (p.colorTheme === 'transparent' ? 1 : 0.4)};
  padding-right: ${em(20)};
  border-top: 1px solid ${p => p.theme.colors.transparent};
`

export const Arrow = styled.div`
  ${({
    theme: {
      arrows: { arrowDownSize, arrowDownPadding },
      animation: { timeStandard },
    },
  }) => css`
    width: ${arrowDownSize};
    height: ${arrowDownSize};
    padding: ${arrowDownPadding};
    transition: transform ${timeStandard};
    flex-shrink: 0;
  `}
`

export const TextLHStyled = styled(TextLH)`
  ${p =>
    p.indicator === 'plus' &&
    css`
      font-size: ${p => p.theme.typography.textUppercase};
    `}

  & b {
    font-family: ${p => p.theme.typography.mediumFont};
    font-weight: 400;
  }
`

export const Stick = styled.div`
  position: absolute;
  left: ${em(5)};
  top: ${em(8)};
  width: ${em(8)};
  height: ${em(2)};
  transform-origin: 50% 50%;
  transition: transform ${p => p.theme.animation.timeStandard} ease-in-out;

  ${({ isVertical }) =>
    isVertical &&
    css`
      transform: rotate(-90deg);
    `}
`

export const Plus = styled.div`
  position: relative;
  align-self: flex-start;
  flex-shrink: 0;
  width: ${em(18)};
  height: ${em(18)};
  top: ${em(4)};
  flex-shrink: 0;
  border-radius: 50%;
  background: ${p => p.theme.colors[p.background]};

  ${p =>
    p.background === 'white' &&
    css`
      ${Stick} {
        background: ${p => p.theme.colors.black};
      }
    `}

  ${p =>
    p.background === 'black' &&
    css`
      ${Stick} {
        background: ${p => p.theme.colors.white};
      }
    `}

  ${p => p.theme.mq.upMd} {
    top: ${em(8)};
  }
`

export const Item = styled.div`
  &:not(:last-child) {
    ${Inner} {
      border-bottom: 1px solid
        ${p =>
          p.colorTheme === 'dark'
            ? p.theme.colors.whiteOp2
            : p.theme.colors.blackOp07};
    }
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      ${Inner} {
        border-color: transparent !important;
        opacity: 1;
      }

      & + ${Item} ${Inner} {
        border-top-color: ${p =>
          p.colorTheme === 'dark'
            ? p.theme.colors.whiteOp2
            : p.theme.colors.blackOp07};
      }

      ${Arrow} {
        transform: rotateZ(-180deg);
      }

      ${Stick} {
        transform: none;
      }
    `}
`

export const Title = styled.div`
  flex: 1 1 auto;
  padding-right: ${em(30)};

  &:focus {
    outline: none;
  }
`

export const Body = styled.div`
  background-color: ${p =>
    p.colorTheme === 'dark'
      ? p.theme.colors.mineShaft
      : p.colorTheme === 'transparent'
      ? p.theme.colors.transparent
      : p.theme.colors.pictonBlue};
  color: ${p =>
    p.colorTheme === 'transparent'
      ? p.theme.colors.bodyColor
      : p.theme.colors.white};
  position: relative;
  margin-left: -${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    margin-left: 0;
  }

  &:before {
    ${({
      colorTheme,
      theme: {
        arrows: { faqArrowSize, faqArrowSizeMd },
        colors: { pictonBlue, mineShaft, transparent },
        indents: { baseIndentXs, baseIndentMd },
        animation: { timeStandard },
        mq: { upMd },
      },
    }) => css`
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-color: transparent transparent
        ${colorTheme === 'dark'
          ? mineShaft
          : colorTheme === 'transparent'
          ? transparent
          : pictonBlue}
        transparent;
      border-width: 0 ${faqArrowSize} ${faqArrowSize} ${faqArrowSize};
      top: -${faqArrowSize};
      left: ${baseIndentXs};
      position: absolute;
      transition: opacity ${timeStandard};
      transition-duration: ${timeStandard};
      transition-delay: 0s;
      ${upMd} {
        border-width: 0 ${faqArrowSizeMd} ${faqArrowSizeMd} ${faqArrowSizeMd};
        top: -${faqArrowSizeMd};
        left: ${baseIndentMd};
      }
    `}
  }

  ${({
    isHidden,
    theme: {
      animation: { timeFastest },
    },
  }) =>
    isHidden &&
    css`
      &:before {
        opacity: 0;
        transition-delay: ${timeFastest};
      }
    `}
`

export const BodyInner = styled.div`
  height: 0;
  transition: height ${p => p.theme.animation.timeStandard};
  overflow: hidden;
  will-change: height;

  ${({ isHeightChange, accordionBodyHeight }) =>
    isHeightChange &&
    css`
      height: ${accordionBodyHeight}px;
    `}
`

export const TextBox = styled.div`
  padding: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding: ${em(40)};
  }
`
